module.exports = __webpack_public_path__ + "66b0a6fb98d8b715efe165af64eea5d5.svg";